var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGa = function SvgGa(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffe700",
    d: "M512 512H0V0h512z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#36a100",
    d: "M512 170.7H0V0h512z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#006dbc",
    d: "M512 512H0V341.3h512z"
  }))));
};
export default SvgGa;